import { Grid, IconButton, styled } from "@mui/material";
import { PageTitle } from "./PageTitle";
import React from "react";
import { ArrowBack } from "@mui/icons-material";
import { Link } from "react-router-dom";

const SmallerPageTitle = styled(PageTitle)(({ theme }) => ({
    fontSize: "18px",
    lineHeight: "28px",
}));

type PageToolbarProps = React.PropsWithChildren<
    {
        title: React.ReactNode;
        /**
         * Controls the url that the back arrow returns you to
         */
        returnTo?: string;
        onReturn?: () => void;
    } & React.ComponentPropsWithoutRef<typeof Grid>
>;

export function PageToolbar({
    title,
    returnTo,
    onReturn,
    ...props
}: PageToolbarProps) {
    return (
        <Grid
            container
            justifyContent="space-between"
            alignItems="center"
            flexWrap="nowrap"
            paddingBlock={1}
            paddingInline={5}
            {...props}
            sx={[
                (theme) => ({
                    backgroundColor: theme.palette.white.main,
                    boxShadow: "0px 0px 2px 0px rgba(0, 0, 0, 0.07)",
                }),
                ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
            ]}
        >
            <Grid container item columnGap={1}>
                <Grid item>
                    <Link className="pendo-ignore" to={returnTo ?? "../"}>
                        <IconButton size="small" onClick={() => onReturn?.()}>
                            <ArrowBack />
                        </IconButton>
                    </Link>
                </Grid>
                <Grid container item alignItems="center" width="fit-content">
                    <SmallerPageTitle>{title}</SmallerPageTitle>
                </Grid>
            </Grid>
            {props.children}
        </Grid>
    );
}
